<template>
  <div class="goods">
    <div class="goods-card" v-for="(goods, idx) in goodsList" :key="'goods_' + idx" @mouseenter="showGoods = idx"
         @mouseleave="showGoods = -1">
      <div class="goods-item" @click="handleDetail(goods)">
        <zy-square >
          <img :src="goods.goods_img" class="image"/>
        </zy-square>
        <div class="cnt">
          <div class="goods-title">
            {{goods.title}}
          </div>
          <div class="commissions">
            <div class="commission">
              <div class="value">
                {{goods.cost_price}}
              </div>
              <div class="title">
                券后
              </div>
            </div>
            <div class="commission">
              <div class="value">
                {{goods.commission_rate}}%
              </div>
              <div class="title">
                佣金比例
              </div>
            </div>
            <div class="commission">
              <div class="value">
                {{goods.commission}}
              </div>
              <div class="title">
                返佣
              </div>
            </div>
          </div>
        </div>

        <div v-if="showGoods === idx" style="position: relative;">
          <div class="more">
            <div class="line"></div>
            <div style="padding-left: 20px;padding-right: 10px;">
              <div class="desc">
                <div>原价：{{goods.price}}元（{{goods.discount}}折）</div>
                <div>销量：{{goods.sales}}</div>
              </div>
              <div class="shop">
                <div class="shop-name">
                  {{goods.shop_name}}
                </div>

                <img class="button" :src="icon" @click.stop="handleAddCollection(goods)">
              </div>
            </div>

          </div>
        </div>

        <div v-if="showGoods === idx" class="ope-panel">
          <div class="btn" @click.stop="shareGoods(goods)">
            分享
          </div>
          <div class="line"></div>
          <div class="btn" @click.stop="addWindow(goods)">
            加橱窗
          </div>
          <div class="line"></div>
          <div class="btn">
            领样
          </div>
        </div>


      </div>
    </div>

    <zy-add-collection-dialog ref="addCollection" />
    <zy-add-window-dialog ref="addWindow" />
    <zy-share-dialog ref="shareGoods"/>

  </div>
</template>

<script>
import ZySquare from "@/components/zy-square/index.vue";
import ZyAddCollectionDialog from "@/components/zy-add-collection-dialog/index.vue";
import ZyAddWindowDialog from "@/components/zy-add-window-dialog/index.vue"
import ZyShareDialog from "@/components/zy-share-dialog/index.vue";

export default {
  name: "goods-list",
  components: {
    ZySquare,
    ZyAddCollectionDialog,
    ZyAddWindowDialog,
    ZyShareDialog,
  },
  props: {
    goodsList: Array,
  },
  data() {
    return {
      showGoods: -1,
      icon: require('@/assets/images/base/store.png'),
    }
  },
  methods: {
    handleDetail(goods) {
      console.log(goods)
      this.$router.push({
        path: '/goods-detail',
        query: {
          id: goods.good_id,
          pvd: goods.provider,
        }
      })
    },
    handleAddCollection(goods) {
      this.$refs.addCollection.show(goods)
    },
    addWindow(goods) {
      this.$refs.addWindow.show(goods)
    },
    shareGoods(goods) {
      this.$refs.shareGoods.show(goods)
    }

  },

}
</script>

<style scoped lang="scss">

.goods {
  display: flex;
  flex-wrap: wrap;
  margin-top: 2.08vw;

  .goods-card {
    width: 20%;
    padding: 10px;
  }
  @media screen and (max-width:500px){
    .goods-card{
      width: 50%;
    }
  }
  @media screen and (min-width:500px) and (max-width:768px){
    .goods-card{
      width: 33%;
    }
  }
  @media screen and (min-width:768px) and (max-width:992px){
    .goods-card{
      width: 25%;
    }
  }
  //@media screen and (max-width: 992px) {
  //  .goods-card {
  //    width: 25%;
  //  }
  //}

  .goods-item {
    background: #FFFFFF;
    box-shadow: 0px 2px 13px 0px rgba(131, 131, 131, 0.17);
    border-radius: 12px;
    position: relative;
    padding-bottom: 12px;
    cursor: pointer;

    .image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-top-left-radius: 12px;
      border-top-right-radius: 12px;
    }
    .cnt {
      //height: 133px;
      //padding: 16px 20px;

      .goods-title {
        font-size: 14px;
        color: #000000;
        line-height: 20px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        margin: 16px 20px 8px 20px;
      }
      .commissions {
        display: flex;
        justify-content: space-around;
        padding-left: 8px;
        padding-right: 8px;
        .commission {
          display: flex;
          flex-direction: column;
          align-items: center;
          .title {
            font-size: 12px;
            color: rgba(0,0,0,0.5);
            line-height: 17px;
          }
          .value {
            font-size: 20px;
            font-family: DIN;
            font-weight: bold;
            color: #000000;
            line-height: 24px;
          }
        }
      }


    }

    .ope-panel {
      z-index: 2;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      background: rgba(0,0,0,0.66);
      border-radius: 12px 12px 0px 0px;
      height: 30px;
      display: flex;
      .btn {
        font-size: 16px;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 30px;
        text-align: center;
        cursor: pointer;
        flex: 1;
      }
      .line {
        width: 1px;
        height: 30px;
        background: #F9F9F999;
      }

    }
    .more {
      z-index: 2;
      position: absolute;
      padding-bottom: 10px;
      top: 0;
      left: 0;
      right: 0;
      background: #FFFFFF;
      box-shadow: 0px 10px 10px 0px rgba(131,131,131,0.17);
      border-bottom-left-radius: 12px;
      border-bottom-right-radius: 12px;

      .line {
        border-top: 1px dashed #edecec;
        margin-top: 8px;
        margin-bottom: 16px;
      }

      .desc {
        font-size: 12px;
        color: #5A5A5A;
        line-height: 17px;
      }

      .shop {
        display: flex;
        align-items: center;
        font-size: 12px;
        margin-top: 8px;
        font-weight: 500;
        color: #000000;
        line-height: 24px;


        .shop-name {
          text-overflow: ellipsis;// 显示省略符号来代表被修剪的文本
          white-space: nowrap; //文本不会换行，文本会在在同一行上继续，直到遇到标签为止
          overflow: hidden;// 超出部分隐藏
          flex-grow: 1;
        }

        .button {
          flex-shrink: 0;
          width: 40px;
          height: 30px;
          margin-left: 10px;
          cursor: pointer;
        }
      }
    }
  }
}

</style>
